import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import InterestedUsers from "../../InterestedUsers";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import Discussion from "../common/Discussion";

//shared safari view

const ShareSafari = () => {
  const { safariViewData } = useSharedSafariContext();

  return (
    <>
      <section className="safari_wrapper margin_bottomfooter pt-3">
        <Container fluid='xxl'>
          <Row className="mb-5 pb-lg-5 pb-0">
            <Col lg={9} className="mb-4">
              <Discussion />
            </Col>
            <Col lg={3} className="mb-lg-0 mb-3">
              <InterestedUsers />
            </Col>
          </Row>
          <Row className="pb-5 d-lg-none">
            <Col className="col-12 text-center">
              <div className="joinshareView mt-md-0 mt-3">
                <Link
                  to="/sharesafari"
                  className="btn_shareView pakage"
                  data-pjax="0"
                >
                  {" "}
                  <i className="fa-solid fa-arrow-left me-2"></i> Back
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ShareSafari;
